import React from 'react';
export function EditorStyleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9 13.4c.84-.7.95-1.96.24-2.8l-5.36-6.46c-.35-.41-.83-.67-1.37-.71-.53-.04-1.06.12-1.47.48l-1.58 1.36-1.59-1.9c-.35-.42-.98-.48-1.41-.13-.42.35-.48.98-.13 1.41l1.61 1.93-2.92 2.51-1.82 1.57c-.83.71-.93 1.96-.24 2.8l5.39 6.42c.34.41.82.66 1.36.7h.17c.48 0 .93-.17 1.3-.48l4.93-4.22 2.89-2.48zm-9.78-5.29l2.11 2.53c.2.24.48.36.77.36.23 0 .45-.08.64-.23.42-.35.48-.98.13-1.41L11.64 6.8l1.6-1.38 5.36 6.46-2.37 2.03-7.9-4.26 1.79-1.54zM20.04 16.28s-.07-.05-.09 0c-.29 1.04-1.96 2.71-1.96 3.72 0 1.1.9 2 2 2s2-.9 2-2c0-1.01-1.67-2.67-1.96-3.72h.01z"
  }));
}